export const paths = {
  any: '*',
  dashboard: {
    root: '/dashboard',
    tickets: {
      root: '/dashboard/tickets',
      any: '/dashboard/tickets/*',
      new: '/dashboard/tickets/new',
      details: '/dashboard/tickets/:ticketId',
      edit: '/dashboard/tickets/:ticketId/edit',
      comments: '/dashboard/tickets/:ticketId/comments',
      commentsNew: '/dashboard/tickets/:ticketId/comments/new',
      relatedTasks: '/dashboard/tickets/:ticketId/related-tasks',
      relatedTasksNew: '/dashboard/tickets/:ticketId/related-tasks/new',
      activityLog: '/dashboard/tickets/:ticketId/activity-log',
    },
    tasks: {
      root: '/dashboard/tasks',
      any: '/dashboard/tasks/*',
      new: '/dashboard/tasks/new',
      details: '/dashboard/tasks/:taskId',
      edit: '/dashboard/tasks/:taskId/edit',
      subtasks: '/dashboard/tasks/:taskId/subtasks',
      subtasksNew: '/dashboard/tasks/:taskId/subtasks/new',
      subtasksEdit: '/dashboard/tasks/:taskId/subtasks/:subtaskId/edit',
      comments: '/dashboard/tasks/:taskId/comments',
      commentsNew: '/dashboard/tasks/:taskId/comments/new',
      activityLog: '/dashboard/tasks/:taskId/activity-log',
    },
  },
  revenue: {
    root: '/revenue',
  },
  audits: {
    root: '/audits',
  },
  organizations: {
    root: '/organizations',
    details: {
      root: '/organizations/:organizationId',
      tab: '/organizations/:organizationId/:tab',
      vendors: '/organizations/:organizationId/vendors/:vendorId',
      vendorsTab: {
        root: '/organizations/:organizationId/vendors/:vendorId/:subTab',
        new: '/organizations/:organizationId/vendors/new',
        children: {
          details: ':vendorId/:subTab',
        },
        information: {
          basicInformationEdit:
            '/organizations/:organizationId/vendors/:vendorId/information/basicInformation/edit',
          billPayEdit:
            '/organizations/:organizationId/vendors/:vendorId/information/billPay/edit',
        },
        contacts: {
          new: '/organizations/:organizationId/vendors/:vendorId/contacts/new',
          edit: '/organizations/:organizationId/vendors/:vendorId/contacts/:contactId/edit',
        },
      },
      work: {
        actionItems: {
          root: '/organizations/:organizationId/work/action-items',
          any: '/organizations/:organizationId/work/action-items/*',
          details:
            '/organizations/:organizationId/work/action-items/:actionItemId',
          edit: '/organizations/:organizationId/work/action-items/:actionItemId/edit',
        },
        tickets: {
          root: '/organizations/:organizationId/work/tickets',
          any: '/organizations/:organizationId/work/tickets/*',
          new: '/organizations/:organizationId/work/tickets/new',
          details: '/organizations/:organizationId/work/tickets/:ticketId',
          edit: '/organizations/:organizationId/work/tickets/:ticketId/edit',
          comments:
            '/organizations/:organizationId/work/tickets/:ticketId/comments',
          commentsNew:
            '/organizations/:organizationId/work/tickets/:ticketId/comments/new',
          relatedTasks:
            '/organizations/:organizationId/work/tickets/:ticketId/related-tasks',
          relatedTasksNew:
            '/organizations/:organizationId/work/tickets/:ticketId/related-tasks/new',
          activityLog:
            '/organizations/:organizationId/work/tickets/:ticketId/activity-log',
        },
        tasks: {
          root: '/organizations/:organizationId/work/tasks',
          any: '/organizations/:organizationId/work/tasks/*',
          new: '/organizations/:organizationId/work/tasks/new',
          details: '/organizations/:organizationId/work/tasks/:taskId',
          edit: '/organizations/:organizationId/work/tasks/:taskId/edit',
          subtasks:
            '/organizations/:organizationId/work/tasks/:taskId/subtasks',
          subtasksNew:
            '/organizations/:organizationId/work/tasks/:taskId/subtasks/new',
          subtasksEdit:
            '/organizations/:organizationId/work/tasks/:taskId/subtasks/:subtaskId/edit',
          comments:
            '/organizations/:organizationId/work/tasks/:taskId/comments',
          commentsNew:
            '/organizations/:organizationId/work/tasks/:taskId/comments/new',
          activityLog:
            '/organizations/:organizationId/work/tasks/:taskId/activity-log',
        },
        recurringTasks: {
          root: '/organizations/:organizationId/work/recurring-tasks',
          any: '/organizations/:organizationId/work/recurring-tasks/*',
          new: '/organizations/:organizationId/work/recurring-tasks/new',
          details:
            '/organizations/:organizationId/work/recurring-tasks/:recurringTaskId',
          edit: '/organizations/:organizationId/work/recurring-tasks/:recurringTaskId/edit',
        },
        emails: {
          root: '/organizations/:organizationId/work/emails',
          any: '/organizations/:organizationId/work/emails/*',
        },
      },
      locations: {
        new: '/organizations/:organizationId/locations/new',
        edit: '/organizations/:organizationId/locations/:locationId/edit',
      },
      vsr: {
        dataEntry: {
          root: '/organizations/:organizationId/vsr/data-entry',
          any: '/organizations/:organizationId/vsr/data-entry/*',
        },
        reportBuilder: {
          root: '/organizations/:organizationId/vsr/report-builder',
          any: '/organizations/:organizationId/vsr/report-builder/*',
        },
      },
      users: {
        clientContacts: {
          root: '/organizations/:organizationId/users/client-contacts',
          any: '/organizations/:organizationId/users/client-contacts/*',
          new: '/organizations/:organizationId/users/client-contacts/new',
          details:
            '/organizations/:organizationId/users/client-contacts/:contactId',
          edit: '/organizations/:organizationId/users/client-contacts/:contactId/edit',
        },
        sibEmployees: {
          root: '/organizations/:organizationId/users/sib-employees',
          any: '/organizations/:organizationId/users/sib-employees/*',
          details:
            '/organizations/:organizationId/users/sib-employees/:employeeId',
        },
      },
      billPay: {
        edit: '/organizations/:organizationId/billPay/edit',
      },
      vendorAccounts: {
        new: '/organizations/:organizationId/vendorAccounts/new',
        edit: '/organizations/:organizationId/vendorAccounts/:vendorAccountId/edit',
      },
      sibContracts: {
        details: '/organizations/:organizationId/sibContracts/:sibContractId',
        edit: '/organizations/:organizationId/sibContracts/:sibContractId/edit',
      },
      services: {
        sibContract: {
          details: '/organizations/:organizationId/services/:sibContractId',
          edit: '/organizations/:organizationId/services/:sibContractId/edit',
        },
      },
      audits: {
        new: '/organizations/:organizationId/audits/new',
      },
      auditDetails: '/organizations/:organizationId/audits/:auditId',
      auditDetailsTab:
        '/organizations/:organizationId/audits/:auditId/:auditTab',
      documents: {
        upload: '/organizations/:organizationId/:tab/upload',
      },
      auditNegotiationsVendors: {
        attach:
          '/organizations/:organizationId/audits/:auditId/negotiations/vendors/attach',
      },
      auditDocuments: {
        attach:
          '/organizations/:organizationId/audits/:auditId/documents/attach',
      },
      auditSpendEstimated: {
        vendorAccountsAttach:
          '/organizations/:organizationId/audits/:auditId/spend-estimated/vendor-accounts/attach',
        vendorAccountsNew:
          '/organizations/:organizationId/audits/:auditId/spend-estimated/vendor-accounts/new',
        spendsNew:
          '/organizations/:organizationId/audits/:auditId/spend-estimated/spends/new',
        spendsImport:
          '/organizations/:organizationId/audits/:auditId/spend-estimated/spends/import',
      },
      auditInitialValidation: {
        spendsNew:
          '/organizations/:organizationId/audits/:auditId/initial-validation/spends/new',
        invoicesNew:
          '/organizations/:organizationId/audits/:auditId/initial-validation/invoices/new',
        invoicesEdit:
          '/organizations/:organizationId/audits/:auditId/initial-validation/invoices/:invoiceId/edit',
      },
      documentsPreview:
        '/organizations/:organizationId/documents/preview/:documentId',
      documentsViewer:
        '/organizations/:organizationId/documents/document/:documentId',
    },
  },
  work: {
    root: '/work',
    tickets: {
      root: '/work/tickets',
      any: '/work/tickets/*',
      new: '/work/tickets/new',
      details: '/work/tickets/:ticketId',
      edit: '/work/tickets/:ticketId/edit',
      comments: '/work/tickets/:ticketId/comments',
      commentsNew: '/work/tickets/:ticketId/comments/new',
      relatedTasks: '/work/tickets/:ticketId/related-tasks',
      relatedTasksNew: '/work/tickets/:ticketId/related-tasks/new',
      activityLog: '/work/tickets/:ticketId/activity-log',
    },
    tasks: {
      root: '/work/tasks',
      any: '/work/tasks/*',
      new: '/work/tasks/new',
      details: '/work/tasks/:taskId',
      edit: '/work/tasks/:taskId/edit',
      subtasks: '/work/tasks/:taskId/subtasks',
      subtasksNew: '/work/tasks/:taskId/subtasks/new',
      subtasksEdit: '/work/tasks/:taskId/subtasks/:subtaskId/edit',
      comments: '/work/tasks/:taskId/comments',
      commentsNew: '/work/tasks/:taskId/comments/new',
      activityLog: '/work/tasks/:taskId/activity-log',
    },
    actionItems: {
      root: '/work/action-items',
      any: '/work/action-items/*',
      details: '/work/action-items/:actionItemId',
      edit: '/work/action-items/:actionItemId/edit',
    },
    recurringTasks: {
      root: '/work/recurring-tasks',
      any: '/work/recurring-tasks/*',
      new: '/work/recurring-tasks/new',
      details: '/work/recurring-tasks/:recurringTaskId',
      edit: '/work/recurring-tasks/:recurringTaskId/edit',
    },
  },
  projects: {
    root: '/projects',
    new: '/projects/new',
    details: {
      root: '/projects/:projectId',
      edit: '/projects/:projectId/edit',
      clone: '/projects/:projectId/clone',
      tab: '/projects/:projectId/:tab',
      files: {
        add: '/projects/:projectId/files/add',
      },
      tickets: {
        root: '/projects/:projectId/tickets',
        any: '/projects/:projectId/tickets/*',
        new: '/projects/:projectId/tickets/new',
        details: '/projects/:projectId/tickets/:ticketId',
        edit: '/projects/:projectId/tickets/:ticketId/edit',
        comments: '/projects/:projectId/tickets/:ticketId/comments',
        commentsNew: '/projects/:projectId/tickets/:ticketId/comments/new',
        relatedTasks: '/projects/:projectId/tickets/:ticketId/related-tasks',
        relatedTasksNew:
          '/projects/:projectId/tickets/:ticketId/related-tasks/new',
        activityLog: '/projects/:projectId/tickets/:ticketId/activity-log',
      },
      tasks: {
        root: '/projects/:projectId/tasks',
        any: '/projects/:projectId/tasks/*',
        new: '/projects/:projectId/tasks/new',
        details: '/projects/:projectId/tasks/:taskId',
        edit: '/projects/:projectId/tasks/:taskId/edit',
        subtasks: '/projects/:projectId/tasks/:taskId/subtasks',
        subtasksNew: '/projects/:projectId/tasks/:taskId/subtasks/new',
        subtasksEdit:
          '/projects/:projectId/tasks/:taskId/subtasks/:subtaskId/edit',
        comments: '/projects/:projectId/tasks/:taskId/comments',
        commentsNew: '/projects/:projectId/tasks/:taskId/comments/new',
        activityLog: '/projects/:projectId/tasks/:taskId/activity-log',
      },
    },
    children: {
      details: ':projectId',
    },
  },
  vendors: {
    root: '/vendors',
    details: {
      root: '/vendors/:vendorId',
      tab: '/vendors/:vendorId/:tab',
      information: {
        basicInformationEdit:
          '/vendors/:vendorId/information/basicInformation/edit',
        billPayEdit: '/vendors/:vendorId/information/billPay/edit',
      },
      contacts: {
        new: '/vendors/:vendorId/contacts/new',
        edit: '/vendors/:vendorId/contacts/:contactId/edit',
      },
      tickets: {
        root: '/vendors/:vendorId/tickets',
        any: '/vendors/:vendorId/tickets/*',
        new: '/vendors/:vendorId/tickets/new',
        details: '/vendors/:vendorId/tickets/:ticketId',
        edit: '/vendors/:vendorId/tickets/:ticketId/edit',
        comments: '/vendors/:vendorId/tickets/:ticketId/comments',
        commentsNew: '/vendors/:vendorId/tickets/:ticketId/comments/new',
        relatedTasks: '/vendors/:vendorId/tickets/:ticketId/related-tasks',
        relatedTasksNew:
          '/vendors/:vendorId/tickets/:ticketId/related-tasks/new',
        activityLog: '/vendors/:vendorId/tickets/:ticketId/activity-log',
      },
      tasks: {
        root: '/vendors/:vendorId/tasks',
        any: '/vendors/:vendorId/tasks/*',
        new: '/vendors/:vendorId/tasks/new',
        details: '/vendors/:vendorId/tasks/:taskId',
        edit: '/vendors/:vendorId/tasks/:taskId/edit',
        subtasks: '/vendors/:vendorId/tasks/:taskId/subtasks',
        subtasksNew: '/vendors/:vendorId/tasks/:taskId/subtasks/new',
        subtasksEdit:
          '/vendors/:vendorId/tasks/:taskId/subtasks/:subtaskId/edit',
        comments: '/vendors/:vendorId/tasks/:taskId/comments',
        commentsNew: '/vendors/:vendorId/tasks/:taskId/comments/new',
        activityLog: '/vendors/:vendorId/tasks/:taskId/activity-log',
      },
    },
  },
  login: '/login',
  redirect: '/redirect',
  storybook: '/storybook',
} as const;

/**
 * Relative path segments used to build nested route trees.
 *
 * React Router children take paths relative to their parent, so they cannot
 * reuse the absolute templates in {@link paths}.
 */
export const ROUTE_SEGMENTS = {
  new: 'new',
  edit: 'edit',
  clone: 'clone',
  add: 'add',
  upload: 'upload',
  actionItems: {
    root: 'action-items',
    details: ':actionItemId',
  },
  recurringTasks: {
    root: 'recurring-tasks',
    details: ':recurringTaskId',
  },
  emails: {
    root: 'emails',
  },
  basicInformationEdit: 'basicInformation/edit',
  billPayEdit: 'billPay/edit',
  contactEdit: ':contactId/edit',
  vsr: {
    dataEntry: {
      root: 'data-entry',
    },
    reportBuilder: {
      root: 'report-builder',
    },
  },
  users: {
    clientContacts: {
      root: 'client-contacts',
      new: 'new',
      details: ':contactId',
      edit: ':contactId/edit',
    },
    sibEmployees: {
      root: 'sib-employees',
      details: ':employeeId',
    },
  },
  locationEdit: ':locationId/edit',
  sibContractId: ':sibContractId',
  sibContractEdit: ':sibContractId/edit',
  tickets: {
    root: 'tickets',
    details: ':ticketId',
    comments: 'comments',
    commentsNew: 'comments/new',
    relatedTasks: 'related-tasks',
    relatedTasksNew: 'related-tasks/new',
    activityLog: 'activity-log',
  },
  tasks: {
    root: 'tasks',
    details: ':taskId',
    subtasks: 'subtasks',
    subtasksNew: 'subtasks/new',
    subtasksEdit: 'subtasks/:subtaskId/edit',
    comments: 'comments',
    commentsNew: 'comments/new',
    activityLog: 'activity-log',
  },
  audits: {
    tab: ':auditTab',
    documentsAttach: 'documents/attach',
    vendorAccountsAttach: 'spend-estimated/vendor-accounts/attach',
    vendorAccountsNew: 'spend-estimated/vendor-accounts/new',
    spendsNew: 'spend-estimated/spends/new',
    spendsImport: 'spend-estimated/spends/import',
    negotiationsVendorsAttach: 'negotiations/vendors/attach',
    initialValidationSpendsNew: 'initial-validation/spends/new',
    invoicesNew: 'initial-validation/invoices/new',
    invoicesEdit: 'initial-validation/invoices/:invoiceId/edit',
  },
} as const;

export type TicketRoutePaths =
  | typeof paths.dashboard.tickets
  | typeof paths.organizations.details.work.tickets
  | typeof paths.projects.details.tickets
  | typeof paths.vendors.details.tickets
  | typeof paths.work.tickets;

export type TaskRoutePaths =
  | typeof paths.dashboard.tasks
  | typeof paths.organizations.details.work.tasks
  | typeof paths.projects.details.tasks
  | typeof paths.vendors.details.tasks
  | typeof paths.work.tasks;

export type ActionItemRoutePaths =
  | typeof paths.organizations.details.work.actionItems
  | typeof paths.work.actionItems;

export type RecurringTaskRoutePaths =
  | typeof paths.organizations.details.work.recurringTasks
  | typeof paths.work.recurringTasks;
